import React from "react";
import PropTypes from "prop-types";

const hStyle = {
  color: "#888792",
  fontFamily: "Rainbow"
};

const Rating = props => {
  return (
    <table>
      <tbody>
        <tr>
          <td rowSpan={2}>
            <img
              src={props.imageUrl}
              alt={props.name}
              width={38}
              height={38}
              className="mr-2"
            />
          </td>
          <td>
            <span style={hStyle}>{props.name}</span>
          </td>
        </tr>
        <tr>
          <td className="text-success">
            <strong>
              <i className="far fa-smile pr-1" />
              {props.value}
              <small>/6</small>
            </strong>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

Rating.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  imageUrl: PropTypes.string
};

export default Rating;
